import { ACT_EVT_CHANGE } from "./ActionTypes";
import EventService from "../provider/event/EventService";
import { loading } from "./AppActions";
import MediaService from "../provider/media/MediaService";

export function actionSelectEvent(event) {
  return (dispatch, getStore) => {
    dispatch({
      type: ACT_EVT_CHANGE,
      props: { event: event },
    });
  };
}
/*** ACTIONS EVENTS ******/
export function actionGetEvents(succesCallback, errorCallback) {
  return (dispatch, getStore) => {
    loading(true)(dispatch, getStore);
    EventService.getEvents(getStore().app.app)
      .then((response) => {
        dispatch({
          type: ACT_EVT_CHANGE,
          props: { eventList: response || [] },
        });
        succesCallback();
      })
      .catch(errorCallback)
      .finally(() => {
        loading(false)(dispatch, getStore);
      });
  };
}

export function actionSaveEvent(
  eventData,
  isCopyWithTickets,
  successCallback,
  errorCallback
) {
  return (dispatch, getStore) => {
    loading(true)(dispatch, getStore);
    let event = { ...eventData, evtName: eventData.evtTitle };
    event.evtDateTime = new Date(event.evtDateTime).getTime();
    // console.log("event.evtDateTime", event.evtDateTime)
    event.evtInitDate = new Date(event.evtInitDate).getTime();
    event.evtEndDate = new Date(event.evtEndDate).getTime();
    if (typeof event.evtImg == "string") {
      //Si tiene una url y no un archivo seleccionado con el componente
      EventService.saveEvent(
        getStore().app.app,
        event,
        isCopyWithTickets,
        getStore().auth.email
      )
        .then((response) => {
          successCallback();
        })
        .catch(errorCallback)
        .finally(() => {
          loading(false)(dispatch, getStore);
        });
    } else {
      //Si tiene un archivo seleccionado por el componente

      MediaService.uploadFile(eventData.evtImg, "events", "image")
        .then((res) => {
          if (event.evtImgPath && event.evtImgPath != res.path) {
            MediaService.deleteFile(event.evtImgPath);
          }
          event.evtImg = res.downloadURL;
          event.evtImgName = res.filename;
          event.evtImgPath = res.path;
          EventService.saveEvent(
            getStore().app.app,
            event,
            isCopyWithTickets,
            getStore().auth.email
          )
            .then((response) => {
              successCallback();
            })
            .catch(errorCallback);
        })
        .catch(errorCallback)
        .finally(() => {
          loading(false)(dispatch, getStore);
        });
    }
  };
}

export function actionDeleteEvent(event, successCallback, errorCallback) {
  return (dispatch, getStore) => {
    loading(true)(dispatch, getStore);
    EventService.deleteEvent(getStore().app.app, event.id)
      .then((response) => {
        MediaService.deleteFile(event.evtImgPath);
        successCallback();
      })
      .catch(errorCallback)
      .finally(() => {
        loading(false)(dispatch, getStore);
      });
  };
}

/****** FIN ACTION EVENTS +**********/
/****** ACTION TICKET TYPES **********/
export function actionGetTicketTypes(succesCallback, errorCallback) {
  return (dispatch, getStore) => {
    loading(true)(dispatch, getStore);
    EventService.getTicketTypesByEvent(
      getStore().app.app,
      getStore().evt.event.id
    )
      .then((response) => {
        dispatch({
          type: ACT_EVT_CHANGE,
          props: { ticketTypeList: response },
        });
        succesCallback && succesCallback();
      })
      .catch(errorCallback)
      .finally(() => {
        loading(false)(dispatch, getStore);
      });
  };
}

export function actionSaveTicketType(
  ticketTypeData,
  successCallback,
  errorCallback
) {
  return (dispatch, getStore) => {
    loading(true)(dispatch, getStore);
    let ticketType = ticketTypeData;
    ticketType.tktEndDate = new Date(ticketType.tktEndDate).getTime();
    ticketType.tktInitDate = new Date(ticketType.tktInitDate).getTime();
    ticketType.tktOutdateDate = new Date(ticketType.tktOutdateDate).getTime();
    // console.log("SAVE TICKET TYPE", ticketType.tktIconFamily, ticketType.tktIcon)
    // if(ticketType.tktIconFamily=="material"){
    //   ticketType.tktIcon = ticketType.tktIcon.substring(3, ticketType.tktIcon.length)
    // }
    EventService.saveTicketType(
      getStore().app.app,
      getStore().evt.event.id,
      ticketType,
      getStore().auth.email
    )
      .then((response) => {
        successCallback();
      })
      .catch(errorCallback)
      .finally(() => {
        loading(false)(dispatch, getStore);
      });
  };
}

export function actionDeleteTicketType(
  ticketTypeId,
  successCallback,
  errorCallback
) {
  return (dispatch, getStore) => {
    loading(true)(dispatch, getStore);
    EventService.deleteTicketType(
      getStore().app.app,
      getStore().evt.event.id,
      ticketTypeId
    )
      .then((response) => {
        successCallback();
      })
      .catch(errorCallback)
      .finally(() => {
        loading(false)(dispatch, getStore);
      });
  };
}

export function actionGetCategories(succesCallback, errorCallback) {
  return (dispatch, getStore) => {
    loading(true)(dispatch, getStore);
    EventService.getCategories(getStore().app.app)
      .then((response) => {
        // console.log("CATEGORIES", response)
        dispatch({
          type: ACT_EVT_CHANGE,
          props: { categoryList: response },
        });
        succesCallback && succesCallback();
      })
      .catch(errorCallback)
      .finally(() => {
        loading(false)(dispatch, getStore);
      });
  };
}
/***** FIN ACTION TICKET TYPES *********/
/****** ACTION TICKETS **********/
export function actionGetTickets(filter, order, limit, succesCallback, errorCallback) {
  return (dispatch, getStore) => {
    loading(true)(dispatch, getStore);
    EventService.getTicketsByEvent(getStore().app.app, filter, order, limit)
      .then((response) => {
        dispatch({
          type: ACT_EVT_CHANGE,
          props: { ticketList: response },
        });
        succesCallback && succesCallback();
      })
      .catch(errorCallback)
      .finally(() => {
        loading(false)(dispatch, getStore);
      });
  };
}

export function actionSaveTickets(tickets, successCallback, errorCallback) {
  return (dispatch, getStore) => {
    loading(true)(dispatch, getStore);
    // let ticket = {
    //   // tktBuyDate:new Date().getTime(),
    //   tktBuyOperationId: 0,
    //   tktBuyerDU: ticketData.tktBuyerDU,
    //   tktCategory: ticketData.tktTicketType.tktCategory,
    //   tktColor: ticketData.tktTicketType.tktColor,
    //   tktDisplayName: ticketData.tktTicketType.tktDisplayName,
    //   tktIcon: ticketData.tktTicketType.tktIcon,
    //   tktIconFamily: ticketData.tktTicketType.tktIconFamily,
    //   tktOrigin:"standard",
    //   tktOwnerDU: ticketData.tktOwnerDU,
    //   tktOwnerLastName: ticketData.tktOwnerLastName,
    //   tktOwnerName: ticketData.tktOwnerName,
    //   tktOwnerName2: ticketData.tktOwnerName + " " + ticketData.tktOwnerLastName,
    //   tktPrice: ticketData.tktTicketType.tktPrice,
    //   tktPriceProducer: ticketData.tktTicketType.tktPriceProducer,
    //   tktRrpp: "",
    //   tktRrppComision: 0,
    //   tktState: "pendingUser",
    //   tktType: ticketData.tktTicketType.id
    // }
    const eventId = getStore().evt.event.id;
    console.log("STORE", getStore());
    // const ticketTypeId = ticketType.id
    // const profileData = profileData
    // const buyOperationId = 0
    EventService.saveTickets(getStore().app.app, eventId, tickets)
      .then((response) => {
        successCallback();
      })
      .catch(errorCallback)
      .finally(() => {
        loading(false)(dispatch, getStore);
      });
  };
}

export function actionTransferTicket(
  requestObj,
  successCallback,
  errorCallback
) {
  return (dispatch, getStore) => {
    loading(true)(dispatch, getStore);
    EventService.transferTicket(getStore().app.app, requestObj)
      .then((response) => {
        successCallback();
      })
      .catch(errorCallback)
      .finally(() => {
        loading(false)(dispatch, getStore);
      });
  };
}
export function actionDeleteTicket(
  ticketId,
  du,
  tktState,
  successCallback,
  errorCallback
) {
  return (dispatch, getStore) => {
    loading(true)(dispatch, getStore);
    EventService.deleteTicket(
      getStore().app.app,
      getStore().evt.event.id,
      ticketId,
      du,
      tktState
    )
      .then((response) => {
        successCallback();
      })
      .catch(errorCallback)
      .finally(() => {
        loading(false)(dispatch, getStore);
      });
  };
}

export function actionGetInvitatios(filter, order, limit, succesCallback, errorCallback) {
  return (dispatch, getStore) => {
    // loading(true)(dispatch, getStore);
    EventService.getInvitationsByEvent(getStore().app.app, filter, order, limit)
      .then((response) => {
        dispatch({
          type: ACT_EVT_CHANGE,
          props: { invitationsList: response },
        });
        succesCallback && succesCallback();
      })
      .catch(errorCallback)
      // .finally(() => {
      //   loading(false)(dispatch, getStore);
      // });
  };
}
/***** FIN ACTION TICKETS *********/
/*** ACTIONS STATISTICS ******/
export function actionStatisticsByEvent(event, succesCallback, errorCallback) {
  return (dispatch, getStore) => {
    loading(true)(dispatch, getStore);
    EventService.getStatistics(getStore().app.app, event.id)
      .then((response) => {
        // console.log("STATISTICS", response)
        dispatch({
          type: ACT_EVT_CHANGE,
          props: { stats: response, eventStats: event },
        });
        succesCallback && succesCallback();
      })
      .catch(errorCallback)
      .finally(() => {
        loading(false)(dispatch, getStore);
      });
  };
}

// export function actionStatisticsRRPPByEvent(eventId, succesCallback, errorCallback) {
//   return (dispatch, getStore) => {
//       loading(true)(dispatch, getStore)
//       EventService.getStatisticsRRPP(getStore().app.app, eventId).then((response) => {
//           // console.log("STATISTICS RRPP", response)
//           dispatch({
//               type:ACT_EVT_CHANGE,
//               props: {
//                 statsRRPPList:response.rrppList,
//                 statsProducerList:response.producerList
//               }
//           })
//           succesCallback&&succesCallback()
//       }).catch(errorCallback)
//       .finally(()=>{loading(false)(dispatch, getStore)})
//   };
// }

export function actionStatisticsDirectRRPPByEvent(
  eventId,
  succesCallback,
  errorCallback
) {
  return (dispatch, getStore) => {
    loading(true)(dispatch, getStore);
    EventService.getStatisticsDirectRRPP(getStore().app.app, eventId)
      .then((response) => {
        console.log("STATISTICS RRPP", response);
        dispatch({
          type: ACT_EVT_CHANGE,
          props: {
            directRrppList: response,
          },
        });
        succesCallback && succesCallback();
      })
      .catch(errorCallback)
      .finally(() => {
        loading(false)(dispatch, getStore);
      });
  };
}

export function actionStatisticsReferencedRRPPByEvent(
  eventId,
  succesCallback,
  errorCallback
) {
  return (dispatch, getStore) => {
    loading(true)(dispatch, getStore);
    EventService.getStatisticsReferencedRRPP(getStore().app.app, eventId)
      .then((response) => {
        // console.log("STATISTICS RRPP", response)
        dispatch({
          type: ACT_EVT_CHANGE,
          props: {
            referencedRrppList: response,
          },
        });
        succesCallback && succesCallback();
      })
      .catch(errorCallback)
      .finally(() => {
        loading(false)(dispatch, getStore);
      });
  };
}
export function actionStatisticsProductorByEvent(
  eventId,
  succesCallback,
  errorCallback
) {
  return (dispatch, getStore) => {
    loading(true)(dispatch, getStore);
    EventService.getStatisticsProducer(getStore().app.app, eventId)
      .then((response) => {
        console.log("PRODUCER RESPONSE", response);
        dispatch({
          type: ACT_EVT_CHANGE,
          props: {
            producerSellList: response,
          },
        });
        succesCallback && succesCallback();
      })
      .catch(errorCallback)
      .finally(() => {
        loading(false)(dispatch, getStore);
      });
  };
}

export function actionStatisticsGiftByEvent(
  eventId,
  succesCallback,
  errorCallback
) {
  return (dispatch, getStore) => {
    loading(true)(dispatch, getStore);
    EventService.getStatisticsGift(getStore().app.app, eventId)
      .then((response) => {
        // console.log("STATISTICS RRPP", response)
        dispatch({
          type: ACT_EVT_CHANGE,
          props: {
            statsGiftDetailList: response,
          },
        });
        succesCallback && succesCallback();
      })
      .catch(errorCallback)
      .finally(() => {
        loading(false)(dispatch, getStore);
      });
  };
}

export function actionStatisticsLoyaltyByEvent(
  eventId,
  succesCallback,
  errorCallback
) {
  return (dispatch, getStore) => {
    loading(true)(dispatch, getStore);
    EventService.getStatisticsLoyalty(getStore().app.app, eventId)
      .then((response) => {
        // console.log("STATISTICS RRPP", response)
        dispatch({
          type: ACT_EVT_CHANGE,
          props: {
            statsLoyaltyDetailList: response,
          },
        });
        succesCallback && succesCallback();
      })
      .catch(errorCallback)
      .finally(() => {
        loading(false)(dispatch, getStore);
      });
  };
}
/***** FIN ACTION STATISTICS *********/



// WEBPACK FOOTER //
// ./src/actions/EventActions.js